<script lang="ts">
    import { Dialog, Modal, Tabs } from "attractions";
    import PurchaseStats from "./PurchaseStats.svelte";
    import PurchaseTable from "./PurchaseTable.svelte";
    import PurchaseUnpaidSummary from "./PurchaseUnpaidSummary.svelte";

    export let open: boolean;

    const availableTabs = ["Wszystkie zakupy", "Statystyki"];
    let selectedTab = availableTabs[0];
</script>

<Modal bind:open let:closeCallback>
    <Dialog title="Historia zakupów" {closeCallback}>
        <Tabs
            class="modalTabs"
            name="menu"
            items={availableTabs}
            bind:value={selectedTab}
        />
        <section class="modalContent">
            {#if selectedTab == availableTabs[0]}
                <PurchaseUnpaidSummary />
                <PurchaseTable />
            {/if}
            {#if selectedTab == availableTabs[1]}
                <PurchaseStats />
            {/if}
        </section>
    </Dialog>
</Modal>